import { DEBOUNCE_TIME } from '../../../utils';
import { useField } from 'formik';
import { useCallback, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useStylovyzeFormContext } from '../contexts/StylovyzeFormContext';
export default function useGetCombinedEvents({ fieldAttrs, onChange, onDebounceChange, onBlur, onFocus, networkError, }) {
    // States definition
    const { stylovyzeFields, setStylovyzeFields } = useStylovyzeFormContext();
    const [field] = useField(fieldAttrs);
    const [stylovyzeField, setStylovyzeField] = useState(stylovyzeFields[field.name]);
    const [isDebouncing, setIsDebouncing] = useState(false);
    // Effects
    useEffect(() => {
        setStylovyzeField(sf => ({ ...sf, networkError }));
    }, [networkError, isDebouncing]);
    useEffect(() => {
        setStylovyzeFields(fields => ({
            ...fields,
            [field.name]: {
                ...stylovyzeField,
            },
        }));
    }, [stylovyzeField]);
    // Combined actions
    const handleDebounceChange = useDebouncedCallback((e, option) => {
        if (onDebounceChange) {
            setStylovyzeField(sf => ({ ...sf, loading: false }));
            onDebounceChange(e, option);
            setIsDebouncing(false);
        }
    }, DEBOUNCE_TIME);
    const combinedHandleChange = (e, option) => {
        setStylovyzeField(sf => ({ ...sf, loading: false }));
        if (field.onChange)
            field.onChange(e);
        if (onChange)
            onChange(e, option);
        if (onDebounceChange) {
            setIsDebouncing(true);
            setStylovyzeField(sf => ({
                ...sf,
                focus: true,
                loading: true,
            }));
            handleDebounceChange.callback(e, option);
        }
    };
    const combinedHandleFocus = (e) => {
        setStylovyzeField(sf => ({ ...sf, focus: true }));
        if (onFocus)
            onFocus(e);
    };
    const combinedHandleBlur = (e) => {
        // Check if we need to call field.onBlur
        if (field.onBlur) {
            field.onBlur(e);
        }
        setStylovyzeField(sf => ({ ...sf, focus: false }));
        if (onBlur)
            onBlur(e);
    };
    const callbackCombinedHandleChange = useCallback(combinedHandleChange, [
        handleDebounceChange,
    ]);
    return {
        onChange: callbackCombinedHandleChange,
        onBlur: combinedHandleBlur,
        onFocus: combinedHandleFocus,
    };
}
